import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ParticipantsPage from "./pages/ParticipantsPage";
import SponsorsPage from "./pages/SponsorsPage";
import JoinStudyPage from "./pages/JoinStudyPage";
import ProvidersPage from "./pages/ProvidersPage";
import OurSponsorsPage from "./pages/OurSponsorsPage";
import AdminPage from "./pages/AdminPage";
import RegistryPage from "./pages/RegistryPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/participants" element={<ParticipantsPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/join-study" element={<JoinStudyPage />} />
          <Route path="/providers" element={<ProvidersPage />} />
          <Route path="/our-sponsors" element={<OurSponsorsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/registry" element={<RegistryPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
